import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPlayFill = (props: SVGProps<SVGSVGElement>) => {
  return <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' fill='none' viewBox='0 0 16 16' {...props} data-sentry-element="svg" data-sentry-component="SvgPlayFill" data-sentry-source-file="PlayFill.tsx">
            <path fill='#fff' fillRule='evenodd' d='M3.89 3.748A.977.977 0 0 1 5.356 2.9l7.85 4.528a.977.977 0 0 1 0 1.692l-7.85 4.527a.977.977 0 0 1-1.464-.845z' clipRule='evenodd' data-sentry-element="path" data-sentry-source-file="PlayFill.tsx" />
        </svg>;
};
export default SvgPlayFill;